module.exports = __webpack_public_path__ + "static/media/day-1.d16035a5.jpg";